const SocketMessageReducers = (
  state = {
    show: false,
    message: "",
    show_game_box_modal: false,
  },
  action
) => {
  switch (action.type) {
    case "SAVE_SOCKET_MESSAGE":
      return action.payload;
    case "CLEAR_SOCKET_MESSAGE":
      return { show: false, message: "", show_game_box_modal: false };
    default:
      return state;
  }
};
export default SocketMessageReducers;
